var styles = {"smaller":"gWgLCEdx90Q-","small":"NukXJ1ku9MQ-","base":"D2y5sdKc6Hs-","large":"iJ3QPjtBbC8-","matchTextColour":"N6oIS7f2exc-"};

export { styles as default };
//# sourceMappingURL=Icon.module.css.js.map
